import React from 'react'
import { Flex } from 'antd'
import type { FlowStep, FlowBranding } from '@/data'
import { SavingsEstimatesBuilder } from './templates/SavingsEstimates'
import { FindingAssistanceBuilder } from './templates/FindingAssistance'
import { GettingStartedBuilder } from './templates/GettingStarted'
import { AIChatLanderBuilder } from './templates/AIChatLander'
import { brandingConfig as aiChatLanderBrandingConfig } from './templates/AIChatLander/config'
import { BrandingEditor } from './BrandingEditor'

interface FormBuilderProps {
  template: string
  state: FlowStep[]
  onChange: (state: FlowStep[]) => void
  onDeleteStep?: (stepId: number) => void
  branding?: FlowBranding
  onBrandingChange?: (branding: FlowBranding) => void
  brandingEnabled?: boolean
  onBrandingToggle?: (enabled: boolean) => void
  promptVersion?: string | null
  onPromptVersionChange?: (version: string | null) => void
}

const cobrandingTemplates = ['savings-estimates', 'getting-started', 'chat']

export const FormBuilder: React.FC<FormBuilderProps> = ({
  template,
  state,
  onChange,
  onDeleteStep,
  branding,
  onBrandingChange,
  brandingEnabled,
  onBrandingToggle,
  promptVersion,
  onPromptVersionChange,
}) => {
  const showBranding =
    cobrandingTemplates.includes(template) &&
    branding &&
    onBrandingChange &&
    onBrandingToggle != null

  const brandingConfig =
    template === 'chat' ? aiChatLanderBrandingConfig : undefined

  const templateBuilder = (() => {
    switch (template) {
      case 'finding-assistance':
        return (
          <FindingAssistanceBuilder
            steps={state}
            onChange={onChange}
            onDeleteStep={onDeleteStep}
          />
        )
      case 'chat':
        return (
          <AIChatLanderBuilder
            promptVersion={promptVersion ?? null}
            onPromptVersionChange={onPromptVersionChange ?? (() => {})}
          />
        )
      case 'getting-started':
        return (
          <GettingStartedBuilder
            steps={state}
            onChange={onChange}
            onDeleteStep={onDeleteStep}
          />
        )
      case 'savings-estimates':
      default:
        return (
          <SavingsEstimatesBuilder
            formSteps={state}
            onChange={onChange}
            onDeleteStep={onDeleteStep}
          />
        )
    }
  })()

  return (
    <Flex vertical gap="middle">
      {showBranding && (
        <BrandingEditor
          branding={branding}
          onChange={onBrandingChange}
          enabled={brandingEnabled ?? false}
          onToggle={onBrandingToggle}
          config={brandingConfig}
        />
      )}
      {templateBuilder}
    </Flex>
  )
}
